window.booleanFormatter = function(value, row) {
    if (value === 1 || value === "true" || value === true) {
        return '<i class="fa fa-check text-success"></i>';
    }
};
